import React, { ReactElement } from 'react';
import { Template } from '../../generated/gql/graphql';
import { useStoreValue } from '../../hooks/use-store-value';
import EditorSelectors from '../../stores/selectors/editor';
import VideoContainer from './video-container';
import Class from '../../utils/classes';

export default function VideoCanvas(): ReactElement {
    const activeTemplate = useStoreValue<Template | undefined>(EditorSelectors.getActiveTemplate());
    const isFormatSpecificActive = useStoreValue<boolean>(EditorSelectors.getIsFormatSpecificActive());

    return (
        <div
            className={Class.classNames(
                'flex h-full w-full flex-col rounded-xl bg-white shadow',
                isFormatSpecificActive ? 'border-2 border-company' : '',
            )}
        >
            {activeTemplate ? <VideoContainer activeTemplate={activeTemplate} /> : <p>Please Select a template</p>}
        </div>
    );
}
